export const createTranslator = (nls, fallback = true) => (strs, ...exprs) => {
  const str = typeof strs === 'string' ? strs : String.raw(strs, ...exprs);

  if (typeof nls[str] === 'undefined') {
    if (fallback) {
      return str;
    }
  }
  return nls[str];
};
